<template>
  <div ref="layout" class="page-query">
    <TableQuery title="" :show-button="false">
      <template #queryButton>
        <form-button
          type="default"
          size="medium"
          icon="form-advance"
          @click="handleCancel"
        >取消</form-button>
        <form-button
          type="primary"
          size="medium"

          @click="saveData"
        >保存</form-button>
      </template>
      <el-form inline size="mini" label-width="100px" label-position="left">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="停货范围">
              <el-select v-model="conditions.stopRange" placeholder="请选择" clearable>
                <el-option
                  v-for="item in stopOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="*生效日期起">
              <el-date-picker
                v-model="conditions.effectiveStartDate"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="*生效日期止">
              <el-date-picker
                v-model="conditions.effectiveEndDate"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <transfer
          v-if="selectDataOptions['A0054'].length>0"
          key="A0054"
          left-header="渠道列表"
          :data-srouce="selectDataOptions['A0054']"
          :data-srouce-columns="dataSrouceColumns54"
          transfer-type="A0054"
          right-header="已选渠道列表"
          @syncTransferSelectedData="syncTransferSelectedData"
        />
        <transfer
          v-if="selectDataOptions['A0019'].length>0"
          key="A0019"
          left-header="存货分类"
          :data-srouce="selectDataOptions['A0019']"
          :data-srouce-columns="dataSrouceColumns54"
          transfer-type="A0019"
          right-header="已选存货分类"
          @syncTransferSelectedData="syncTransferSelectedData"
        />
        <el-form-item class="widget-view remark-item" label="*停发货原因">
          <el-input
            v-model="conditions.stopReason"
            placeholder="请输入"
            resize="none"
            rows="4"
            :autosize="{ minRows: 4, maxRows: 6 }"
            type="textarea"
            clearable
          />
        </el-form-item>
      </el-form>
    </TableQuery>
    <!-- 基地选择 -->
    <TableQuery v-if="conditions.stopRange==='area'" title="" :show-button="false">
      <template #queryButton>
        <el-button size="mini" icon="el-icon-refresh-right" @click="resetBaseQuery">重置</el-button>
        <el-button size="mini" icon="el-icon-search" type="primary" @click="queryDealerData">查询</el-button>
      </template>
      <el-form inline size="mini" label-width="100px" label-position="left">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-select v-model="conditions.saleCenterDistrict" value-key="code" placeholder="请选择" clearable>
                <el-option
                  v-for="item in saleCenterGridOptions"
                  :key="item.code"
                  :label="item.deptName"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地描述">
              <el-input v-model="conditions.baseSearch" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <transfer
          v-if="conditions.saleCenterDistrict&&conditions.saleCenterDistrict.code"
          key="area"
          left-header="基地列表"
          :data-srouce="conditions.saleCenterDistrict"
          :data-srouce-columns="dataSrouceColumnsSaleCenterBase"
          transfer-type="area"
          right-header="已选基地列表"
          @syncTransferSelectedData="syncTransferSelectedData"
        />
      </el-form>
    </TableQuery>
    <!-- 战区选择 -->
    <el-row v-else-if="conditions.stopRange==='war'" class="district-block" :gutter="24">
      <transfer
        v-if="saleCenterGridOptions.length>0"
        key="war"
        left-header="营销单元列表"
        :data-srouce="saleCenterGridOptions"
        :data-srouce-columns="dataSrouceColumnsSaleCenter"
        transfer-type="war"
        right-header="已选营销单元列表"
        @syncTransferSelectedData="syncTransferSelectedData"
      />
    </el-row>
    <!-- 经销商选择 -->
    <TableQuery v-else-if="conditions.stopRange==='dealer'" title="" :show-button="false">
      <template #queryButton>
        <el-button size="mini" icon="el-icon-refresh-right" @click="resetDealerQuery">重置</el-button>
        <el-button size="mini" icon="el-icon-search" type="primary" @click="queryDealerData">查询</el-button>
      </template>
      <el-form inline size="mini" label-width="100px" label-position="left">
        <el-row :gutter="24">
          <el-col :lg="6" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="dealerCondition.rt_zzfld000016" placeholder="请选择" clearable>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="客户编码">
              <el-input v-model="dealerCondition.rt_partner" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="dealerCondition.rt_name_org1" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="营销单元">
              <el-select v-model="dealerCondition.rt_sal_center" placeholder="请选择" clearable>
                <el-option
                  v-for="item in saleCenterGridOptions"
                  :key="item.code"
                  :label="item.deptName"
                  :value="item.deptCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <transfer
          v-if="clientGridOptions.length>0"
          key="dealer"
          left-header="经销商列表"
          :data-srouce="clientGridOptions"
          :data-srouce-columns="dataSrouceColumnsClient"
          transfer-type="dealer"
          right-header="已选经销商列表"
          @syncTransferSelectedData="syncTransferSelectedData"
        />
      </el-form>
    </TableQuery>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { findWlyOrg } from '@/api/client'
import { apiSapClientFindInfo } from '@/api/common'
import { filterSapParams } from '@/utils/index'

import Transfer from './Transfer.vue'
export default {
  components: {
    Transfer
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    mid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      conditions: {
        saleCenterName: '',
        baseSearch: '',
        planType: [],
        brand: [],
        saleCenter: [],
        base: [],
        dealer: [],
        saleCenterDistrict: {},
        effectiveStartDate: '',
        effectiveEndDate: '',
        stopReason: '',
        stopRange: 'dealer'
      },
      dealerCondition: {
        rt_zzfld000016: '',
        rt_partner: '',
        rt_name_org1: '',
        rt_sal_center: ''
      },
      selectDataOptions: {
        'A0054': [],
        'A0019': [],
        'stopDeliveryRange': []
      },
      saleCenterGridOptions: [],
      clientGridOptions: [],
      stopOptions: [
        {
          name: '战区',
          value: 'war'
        },
        {
          name: '基地',
          value: 'area'
        },
        {
          name: '经销商',
          value: 'dealer'
        }
      ],
      dataSrouceColumns54: [
        {
          name: '名称',
          code: 'name'
        },
        {
          name: '编码',
          code: 'value'
        }
      ],
      dataSrouceColumnsSaleCenter: [
        {
          name: '战区',
          code: 'deptName'
        },
        {
          name: '编码',
          code: 'deptCode'
        }
      ],
      dataSrouceColumnsSaleCenterBase: [
        {
          name: '营销单元',
          code: 'pdeptCode'
        },
        {
          name: '营销中心描述',
          code: 'pdeptName'
        },
        {
          name: '基地编码',
          code: 'deptCode'
        },
        {
          name: '基地描述',
          code: 'deptName'
        }
      ],
      dataSrouceColumnsClient: [
        {
          name: '客户编号',
          code: 'partner'
        },
        {
          name: '客户名称',
          code: 'name_org1'
        },
        {
          name: '客户类型',
          code: 'zzfld000016_text'
        }
      ]
    }
  },
  created() {
    // 停发货范围
    this.getSelectDictDataOrigin('stopDeliveryRange')
    // 渠道
    this.getSelectDictDataOrigin('A0054')
    // 存货分类
    this.getSelectDictDataOrigin('A0019')
    // 客户类型
    this.getSelectDictDataOrigin('A0009')
    // 组织机构查询
    this.findWlyOrg()
  },
  methods: {
    saveData() {
      this.$emit('close', this.conditions)
    },
    syncTransferSelectedData(data, type) {
      console.log('-syncTransferSelectedData===========', data, type)
      switch (type) {
        case 'A0054':
          this.conditions.planType = data
          break
        case 'A0019':
          this.conditions.brand = data
          break
        case 'war':
          this.conditions.saleCenter = data
          break
        case 'area':
          this.conditions.base = data
          break
        case 'dealer':
          this.conditions.dealer = data
          break
      }
    },
    // 查询客户主数据
    async queryDealerData() {
      try {
        // const { page, pagesize } = this.pagination
        const params = { ...filterSapParams(this.dealerCondition, { cp: ['rt_partner', 'rt_name_org1'] }), page: 1, pagesize: 200 }
        // 当前登录账号和角色
        params.partner = this.$store.getters.role.USER_BP
        params.role = this.$store.getters.role.ROLE
        const res = await apiSapClientFindInfo(params)
        if (res.msgtype === 'S') {
          this.clientGridOptions = res.data.map(v => v.info)
        }
      } catch (e) {
        //
      }
    },
    // 获取组织机构
    async findWlyOrg() {
      const { data } = await findWlyOrg()
      this.saleCenterGridOptions = data
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    resetDealerQuery() {
      this.dealerCondition = {
        rt_zzfld000016: '',
        rt_partner: '',
        rt_name_org1: '',
        rt_sal_center: ''
      }
    },
    resetBaseQuery() {
      this.conditions.saleCenterDistrict = {}
      this.conditions.baseSearch = ''
    },
    handleCancel() {
      this.$emit('close', this.conditions)
    }
  }
}
</script>
<style scoped lang="scss">
    .remark-item{
        margin-top:20px;
    }
    .district-block{
        padding: 0 60px;
    }
    /deep/ .el-icon-search{
      line-height:28px;
    }
    /deep/ .el-icon-refresh-right{
       line-height:28px;
    }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/components/DeliverySettingsEdit.vue